module.exports = __webpack_public_path__ + "img/Monte_Kope_111.2634a2f3.jpg";